import React, { useMemo } from 'react';

import { Alert, Copy, Typography } from '@gogame/components';
import { useScreenMessage } from '@gogame/screens';

const AffiliateNode = () => {
  const { showSuccessMessage } = useScreenMessage();
  const welcomeText = useMemo(() => {
    return (
      `Shareable Link Instructions for the Affiliate. \n` +
      `I'd like the placeholder of {placement} and {publisher} to be changed to the relevant macros of account manager or affiliate.  \n` +
      `Please note that other than that the links must stay as is, including all parameters and values.  \n` +
      `If you wish to add additional parameters for your usage, feel free to do so as long as the existing part of the link doesn't change.`
    );
  }, []);

  const handleCopy = () => {
    showSuccessMessage('Text copied to your clipboard');
  };
  return (
    <Alert
      title={'Shareable Link Instructions for the Affiliate'}
      action={<Copy onCopy={handleCopy} value={welcomeText} />}
    >
      <Typography variant={'inherit'} gutterBottom>
        I'd like the placeholder of &#123;placement&#125; and
        &#123;publisher&#125; to be changed to the relevant macros of account
        manager or affiliate.
      </Typography>
      <Typography variant={'inherit'} gutterBottom>
        Please note that other than that the links must stay as is, including
        all parameters and values.
      </Typography>
      <Typography variant={'inherit'}>
        If you wish to add additional parameters for your usage, feel free to do
        so as long as the existing part of the link doesn't change.
      </Typography>
    </Alert>
  );
};
export default AffiliateNode;
